import { faPhoneOffice, faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Badge, Col, Row } from 'react-bootstrap-5';
import { useSelector } from 'react-redux';
import { selectOffMarketAiCompanies } from 'bundles/connect/components/store/selectors/off_market_property';
import { selectCallConsoleAiCompanies } from 'bundles/connect/components/store/selectors/call_console';
import AiFeedback from '../../feedback/ai_feedback';

type Props = {
  fromConsole?: boolean;
}

export default function AiRelatedCompanies(
  { fromConsole = false }: Props
) {
  const aiRelatedCompanies = useSelector(
    fromConsole ? selectCallConsoleAiCompanies : selectOffMarketAiCompanies
  );

  if (aiRelatedCompanies.length < 1) return null;

  return (
    <div className="d-flex flex-column gap-3">
      <div className="fs-large fw-bolder">Related Companies</div>
      <Row className="g-3">
        {aiRelatedCompanies.map(comp => (
          <Col className="d-flex flex-column gap-0-5" key={comp.name} md={6} xs={12} >
            <div className="ai-section">
              <div className="d-flex align-items-center justify-content-between">
                <Badge bg="" className="badge-gradient badge-sm py-0-5">
                  <FontAwesomeIcon icon={faSparkles} size="xs"/>
                  <span className="fs-x-small">AI Research</span>
                </Badge>
                <AiFeedback fromConsole={fromConsole} obj={comp} objType="Connect::AiRelatedCompany" />
              </div>
              <div className="fs-large fw-bold">{comp.name}</div>
              {comp.website && <a className="fs-small" href={comp.website}>{comp.website}</a>}
            </div>
            {comp.phoneNumbers.length > 0 && (
              <div className="ai-section">
                <div className="d-flex gap-1">
                  <FontAwesomeIcon className="text-muted py-1" icon={faPhoneOffice} />
                  <div>
                    <a
                      className="text-link p-0 fs-small"
                      href={comp.phoneNumbers[0].number}
                    >
                      {comp.phoneNumbers[0].formatted}
                    </a>
                    <div className="fs-x-small text-muted">Phone</div>
                  </div>
                </div>
              </div>
            )}
            {comp.reasoning && (
              <div className="ai-section d-flex gap-1">
                <FontAwesomeIcon className="text-secondary py-1" icon={faSparkles} />
                <span className="fs-small">{comp.reasoning}</span>
              </div>
            )}
          </Col>
        ))}
      </Row>
    </div>
  );
}
